/* eslint-disable global-require */
/* eslint-disable max-len */
/**
 * free assessment 页配置
 */

export default {
  banner: {
    title: '1-ON-1 FREE<br>EVALUATION',
    description: '1v1 Evaluation is for all grade-level kids. Before we having an evaluation with a Think Academy teacher, you will be invited to take an entry assessment, which will test your child\'s mathematic competency and learning abilities.',
    buttonName: ['Free Math Evaluation'],
    tip: '',
    buttonWidth: '',
    className: 'banner-us',
  },
  intro: {
    title: 'What is 1-On-1 Free Evaluation',
    list: [{
      title: '15 Well-Designed Competency Questions',
      description: 'Your child will take a grade-specific evaluation exam. The exam results will give you a clear and holistic understanding of your childs\' current math comprehension and abilities.',
      iconName: 'icon-6',
      picture: require('assets/images/free-assessment/icon-13.svg'),
    }, {
      symbol: '+',
    }, {
      title: 'One-Hour In-Depth Analysis',
      description: 'Explain which concepts your child needs more guidance on; Outline a learning path to solve similar problems in future;  Provide a customized and comprehensive future study plan.',
      iconName: 'icon-5',
      picture: require('assets/images/free-assessment/icon-10.svg'),
    }, {
      symbol: '=',
    }, {
      title: 'Think Academy 1-On-1 Evaluation',
      description: 'Once the evaluation is completed, we hope your child will continue their learning adventure with one of our Think Academy courses.',
      iconName: 'icon-3',
      picture: require('assets/images/common/icon-logo.svg'),
    }],
  },
  advantage: {
    title: 'What the 1-On-1 Evaluation Provides',
    list: [{
      title: 'An overview of the Think Academy mission and academic structure',
      iconName: 'icon-1',
      picture: require('assets/images/free-assessment/icon-9.svg'),
    }, {
      title: 'A 40-minute child evaluation exam walkthrough',
      iconName: 'icon-5',
      picture: require('assets/images/free-assessment/icon-14.svg'),
    }, {
      title: 'A 15-minute teacher / parent feedback and discussion',
      iconName: 'icon-6',
      picture: require('assets/images/free-assessment/icon-15.svg'),
    }, {
      title: 'A customized and comprehensive future study plan',
      iconName: 'icon-7',
      picture: require('assets/images/free-assessment/icon-16.svg'),
    }],
  },
  bookAssessment: [{
    title: 'Please select grade your child leveled in Fall 2022',
    buttonName: 'Evaluate Now',
    gradeData:
    [{
      name: 'Grade K',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1214',
    }, {
      name: 'Grade 1',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1215',
    }, {
      name: 'Grade 2',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1216',
    }, {
      name: 'Grade 3',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1208',
    }, {
      name: 'Grade 4',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1207',
    }, {
      name: 'Grade 5',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1193',
    }, {
      name: 'Pre-Algebra',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1205',
    }, {
      name: 'Algebra 1',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1223',
    }, {
      name: 'Algebra 2',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1212',
    }, {
      name: 'Bridge to A2',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1246',
    }, {
      name: 'Geometry',
      bookUrl: 'https://www.thethinkacademy.com/quiz/evaluation/instruction/1209',
    }],
  }, {
    title: "Please choose your child's Chinese level",
    description: "If you don't know the level of your child, please add WeChat (ID:389652735) for more information",
    buttonName: 'Book Evaluation',
    gradeData:
    [{
      name: 'Level 1 (PreK-G2)',
      bookUrl: 'https://calendly.com/think-chinese/chinese-level1-evaluation',
    }, {
      name: 'Level 2 (G1-G3)',
      bookUrl: 'https://calendly.com/think-chinese/chinese-level2-evaluation',
    }, {
      name: 'Level 3 (G2-G5)',
      bookUrl: 'https://calendly.com/think-chinese/chinese-level3-evaluation',
    }],

  }],
  bookGuide: {
    title: 'Give Your Child A Competitive Edge',
    buttonName: 'Book a FREE Evaluation',
  },
  process: {
    title: 'How the 1-On-1 Evaluation Works',
    list: [{
      step: '01',
      title: 'Complete your entry assessment',
      description: 'Click "Evaluate Now" to start your child\'s evaluation. The test is around 40 mins, no calculator is allowed. Please let your child complete this evaluation on their own.',
      buttonName: 'Evaluate Now',
      buttonIconName: '',
    }, {
      step: '02',
      title: 'Directly register for courses or Book a 1-on-1 meeting',
      description: 'After completing the evaluation, the system will recommend a class based on the test, or you can book a one-on-one session with one of our teachers!',
      buttonName: '',
      buttonIconName: '',
    }, {
      step: '03',
      title: 'Attend 1-on-1 meeting after evaluation',
      description: 'If you choose to take the 1-on-1 meeting after evaluation, we will meet you on Zoom. During the meeting, our teacher will discuss the evaluation questions with your child and then discuss with you about the current maths aptitude level, and the next steps. The meeting will take 45-60 mins.',
      buttonName: '',
      buttonIconName: '',
    }, {
      step: '04',
      title: 'Next Steps',
      description: 'After the meeting, if your child wants to continue learning with Think Academy, our teacher will continue to guide, teach and assess your child as they grow in their mathematical skills!',
      buttonName: '',
      buttonIconName: '',
    }],
  },
  clientSay: {
    title: 'See what previous<br>students say<br>about us',
    buttonName: 'Book Your Evaluation Today',
  },
}
